var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1AB759",
    d: "M40 76.9c20.38 0 36.902-16.52 36.902-36.9C76.902 19.618 60.38 3.097 40 3.097S3.098 19.619 3.098 39.999 19.62 76.901 40 76.901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1AB759",
    d: "M40 80C17.946 80 0 62.057 0 40 0 17.946 17.946 0 40 0c22.057 0 40 17.946 40 40 0 22.057-17.943 40-40 40m0-73.803C21.36 6.197 6.197 21.36 6.197 40S21.36 73.803 40 73.803 73.803 58.637 73.803 40C73.803 21.36 58.64 6.197 40 6.197"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.166 54.717c-.83 0-1.623-.331-2.209-.926L21.524 42.172a3.098 3.098 0 1 1 4.418-4.344l9.135 9.283 18.897-20.812a3.1 3.1 0 0 1 4.374-.21 3.1 3.1 0 0 1 .211 4.377l-21.1 23.238a3.1 3.1 0 0 1-2.23 1.016c-.022-.003-.04-.003-.063-.003"
  })));
};
export default SvgCheck;